var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/isarray@1.0.0/~/isarray/index.js
// module id = 285
// module chunks = 0